import { render, staticRenderFns } from "./base.vue?vue&type=template&id=79eda4a8"
import script from "./base.vue?vue&type=script&lang=ts"
export * from "./base.vue?vue&type=script&lang=ts"
import style0 from "./base.vue?vue&type=style&index=0&id=79eda4a8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports